import React, { useState } from 'react';
import { Button, Spin, Progress, Row, Col, Checkbox, Modal } from 'antd';
import csv from 'csvtojson';
import { useCustomer } from '../hook/CustomerHook';
import { CUSTOMER_SOURCE, CUSTOMER_STATUS } from '../objects/CustomerObject';
import dayjs from 'dayjs';
import { Timestamp } from 'firebase/firestore';
import { getDate } from '../common/Converter';
import * as XLSX from 'xlsx';
import { useSchool } from '../hook/SchoolHook';

export default function SC04_ImportUser(props) {
    const { schools, updateSchool, addNewSchool } = useSchool();
    const { customers, updateCustomer, addNewCustomer } = useCustomer();
    var [running, setRunning] = useState(false);
    var [notice, setNotice] = useState(false);
    var [forceStop, setForceStop] = useState(false);
    var [percent, setPercent] = useState(0);
    var [current, setCurrent] = useState(0);
    var [totalTask, setTotalTask] = useState(0);
    var [warning, setWarning] = useState([]);
    var [errors, setErrors] = useState([]);
    const [data, setData] = useState([]);

    async function asyncPushData(array, callback) {
        for (let index = 0; index < array.length; index++) {
            if (forceStop) {
                index = array.length;
                break;
            }
            else
                await callback(array[index], index, array);
        }
    }
    const validateInfo = (customer) => {
        var result = {
            code: 0,
            message: ""
        };

        if (customer.hasOwnProperty('userId') == false || !customer.userId) {
            result.code = 1;
            result.message = "Trường UserID bị trống";
        } else {
            const userIdExisted = customers.findIndex(c => c.userId === customer.userId) == -1 ? false : true;
            if (userIdExisted) {
                result.code = 1;
                result.message = `UserID "${customer.userId}" đã tồn tại trên hệ thống. Không thể nhập dữ liệu mới này`;
            }
        }
        if (customer.hasOwnProperty('expired') == false || !customer.expired) {
            result.code = 1;
            result.message = (result.message ? `${result.message} & ` : "") + "Ngày hết hạn bị trống";
        }
        if (customer.hasOwnProperty('school') == false || !customer.school) {
            result.code = 1;
            result.message = (result.message ? `${result.message} & ` : "") + "Thông tin trường bị trống";
        }
        if (customer.hasOwnProperty('class') == false || !customer.class) {
            result.code = 1;
            result.message = (result.message ? `${result.message} & ` : "") + "Lớp bị trống";
        }
        if (customer.hasOwnProperty('name') == false || !customer.name) {
            result.code = 1;
            result.message = (result.message ? `${result.message} & ` : "") + "Tên học sinh bị trống";
        }
        if (result.code == 1)
            result.message = "Dòng " + (customer.__rowNum__ + 1) + ": " + result.message
        return result;
    }

    const doImport = async (jsonData) => {
        if (!jsonData) {
            console.log("Data is empty");
            return;
        }
        console.log("Data Import: ", jsonData)

        // var jsonArray = await csv().fromString(data);
        setTotalTask(jsonData.length);

        setRunning(true);
        setNotice("Đang đẩy dữ liệu");

        // let customer = [];
        let done = 0;
        const startTime = Timestamp.now().seconds;
        console.log("START TIME: ", startTime)
        let listMaHs = []
        let listUserId = []

        await asyncPushData(jsonData, async (object) => {
            done++;
            var progressPercent = Math.round((done / jsonData.length * 100) * 100) / 100;
            setPercent(progressPercent);
            console.log("Percent: ", progressPercent);
            console.log("Object: ", object);
            console.log("customer: ", object.userId, object.maHs, object.birthday, object.expired);
            setCurrent(done);
            setNotice("Process data for Customer: " + object.userId);

            const valid = validateInfo(object);
            if (valid.code == 0) {
                if (forceStop == false) {
                    const customerInfo = { ...object }
                    const schoolIndex = schools.findIndex(school => school.id === customerInfo.school)
                    if (schoolIndex == -1) {
                        console.log("schools =======", schools, customerInfo.school)
                        //Add new school
                        let schoolRes = await updateSchool({ id: customerInfo.school, name: customerInfo.school })
                        let allWarning = warning;
                        allWarning.push({ user: customerInfo, type: "school", row: (object.__rowNum__ + 1) });
                        setWarning(allWarning);
                    }
                    customerInfo.source = CUSTOMER_SOURCE.IMPORT_FILE.key;
                    customerInfo.status = CUSTOMER_STATUS.ACTIVE.key;
                    customerInfo.key = customerInfo.userId;
                    const tempBirthday = dayjs(customerInfo.birthday, ["DD/MM/YYYY", "DD/M/YYYY", "D/M/YYYY", "D/M/YY", "D/MM/YYYY", "DD/MM/YY", "DD/M/YY", "D/MM/YY"]);
                    const tempExpired = dayjs(customerInfo.expired, ["DD/MM/YYYY", "D/M/YYYY", "DD/M/YYYY", "D/MM/YYYY", "DD/MM/YY", "D/M/YY", "DD/M/YY", "D/MM/YY"]);

                    console.log("customer Birthday: ", customerInfo.birthday);
                    console.log("customer Expired: ", customerInfo.expired);
                    if (!customerInfo.hasOwnProperty('password') || !customerInfo.password) {
                        customerInfo.password = '123456'

                        let allWarning = warning;
                        allWarning.push({ user: customerInfo, type: "pass", row: (object.__rowNum__ + 1) });
                        setWarning(allWarning);
                    }
                    if (listMaHs.findIndex(t => t === customerInfo.maHs) != -1) {
                        let allWarning = warning;
                        allWarning.push({ user: customerInfo, type: "maHs", row: (object.__rowNum__ + 1) });
                        setWarning(allWarning);
                    } else {
                        listMaHs.push(customerInfo.maHs)
                    }
                    if (listUserId.findIndex(t => t === customerInfo.userId) != -1) {
                        let allWarning = warning;
                        allWarning.push({ user: customerInfo, type: "userId", row: (object.__rowNum__ + 1) });
                        setWarning(allWarning);
                    } else {
                        listUserId.push(customerInfo.userId)
                    }

                    if (tempBirthday.isValid() && tempExpired.isValid()) {

                        customerInfo.birthday = tempBirthday.toDate()
                        customerInfo.expired = tempExpired.toDate()
                        let res = await updateCustomer(customerInfo);
                        if (!res.error) {

                        } else {
                            customerInfo.error = res.message + ` (Dòng ${(object.__rowNum__ + 1)})`;
                            // currentError.push(customerInfo);
                            let allError = errors;
                            allError.push(customerInfo);
                            setErrors(allError);
                            // setErrors([...errors, customerInfo]);
                            console.log("ERROR (User): Cannot push current user code: ", object.maHs);
                            // console.log("ERROR (New Part): Cannot push current user code", currentError);
                        }
                    } else {
                        var oldErrors = errors;
                        if (tempBirthday.isValid() == false) {
                            console.log(" NOT VALIDE ===== customer Birthday: ", customerInfo.birthday);
                            customerInfo.error = `Ngày sinh "${customerInfo.birthday}" không hợp lệ (Dòng ${(object.__rowNum__ + 1)})`;
                            oldErrors.push(customerInfo);
                        }
                        if (tempExpired.isValid() == false) {
                            const dupCus = { ...customerInfo }
                            dupCus.error = `Ngày hết hạn "${customerInfo.expired}" không hợp lệ (Dòng ${(object.__rowNum__ + 1)})`;
                            oldErrors.push(dupCus);
                        }
                        // oldErrors.push(customerInfo);
                        setErrors(oldErrors);
                    }

                }
            } else {
                object.error = valid.message;
                var oldErrors = errors;
                oldErrors.push(object);
                setErrors(oldErrors);
                console.log("ERROR: Cannot push current part code: ", object.maHs);
            }

        });

        const endTime = Timestamp.now().seconds;
        console.log("END TIME: ", startTime)
        const duration = endTime - startTime;
        const min = Math.round(duration / 60);
        const sec = duration % 60;

        setNotice("Đẩy dữ liệu hoàn tất (duration: " + min + "m " + sec + "s)");
        setRunning(false);
    }
    // const doImport = async (data) => {
    //     if (!data) {
    //         console.log("Data is empty");
    //         return;
    //     }

    //     var jsonArray = await csv().fromString(data);
    //     setTotalTask(jsonArray.length);

    //     setRunning(true);
    //     setNotice("Đang đẩy dữ liệu");

    //     let customer = [];
    //     let done = 0;
    //     const startTime = Timestamp.now().seconds;
    //     console.log("START TIME: ", startTime)

    //     await asyncPushData(jsonArray, async (object) => {
    //         done++;
    //         var progressPercent = Math.round((done / jsonArray.length * 100) * 100) / 100;
    //         setPercent(progressPercent);
    //         console.log("Percent: ", progressPercent);
    //         setCurrent(done);
    //         setNotice("Process data for Customer: " + object.phone);

    //         const valid = validateInfo(object);
    //         if (valid.code == 0) {
    //             if (forceStop == false) {
    //                 const customerInfo = { ...object }
    //                 customerInfo.source = CUSTOMER_SOURCE.IMPORT_FILE.key;
    //                 customerInfo.status = CUSTOMER_STATUS.ACTIVE.key;
    //                 customerInfo.key = customerInfo.phone;
    //                 customerInfo.expired = dayjs(customerInfo.expired, "DD/MM/YYYY").toDate()
    //                 if (!customerInfo.hasOwnProperty('password') || !customerInfo.password)
    //                     customerInfo.password = '123456'
    //                 let res = await updateCustomer(customerInfo);
    //                 if (!res.error) {

    //                 } else {
    //                     customerInfo.error = res.message;
    //                     setErrors([...errors, customerInfo]);
    //                     console.log("ERROR (New Part): Cannot push current part code: ", object.index);
    //                 }
    //             }
    //         } else {
    //             object.error = valid.message;
    //             var oldErrors = errors;
    //             oldErrors.push(object);
    //             setErrors(oldErrors);
    //             console.log("ERROR: Cannot push current part code: ", object.index);
    //         }

    //     });

    //     const endTime = Timestamp.now().seconds;
    //     console.log("END TIME: ", startTime)
    //     const duration = endTime - startTime;
    //     const min = Math.round(duration / 60);
    //     const sec = duration % 60;

    //     setNotice("Đẩy dữ liệu hoàn tất (duration: " + min + "m " + sec + "s)");
    //     setRunning(false);
    // }

    const stop = () => {
        setForceStop(true);

        setNotice("Đã ngừng chuyển đổi dữ liệu");
        setRunning(false);
    }

    let fileReader;

    const onLoadFileDone = (e) => {
        // var data = fileReader.result;
        // setJsonData(data);
        setNotice("Upload file finished. Data processing...");
        setErrors([]);
        setTotalTask(0);
        setWarning([]);
        const bstr = e.target.result;
        const workbook = XLSX.read(bstr, {
            type: 'binary',
            cellDates: true
        });
        const sheetName = workbook.SheetNames[0]; // Lấy tên sheet đầu tiên
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, {
            raw: false,
            dateNF: 'dd"/"mm"/"yyyy' // <--- need dateNF in sheet_to_json options (note the escape chars)
        }); // Chuyển đổi sheet thành JSON
        // console.log("JSON: ", json);
        // setData(json);
        doImport(json);
    }
    const errorLoadFile = (error) => {
        setNotice("Error: " + error);
    }

    const handleFileChosen = (file) => {
        try {
            console.log("CHOOSE FILE DONE")
            setCurrent(0);
            setPercent(0);
            fileReader = new FileReader();
            fileReader.onloadend = onLoadFileDone;
            fileReader.readAsText(file);
        } catch (exception) {
            setNotice("Có lỗi cảy ra: ", exception)
        }
    }
    const handleFileUpload = (file) => {
        if (file) {
            try {
                console.log("CHOOSE FILE DONE")
                setCurrent(0);
                setPercent(0);
                fileReader = new FileReader();
                fileReader.onloadend = onLoadFileDone;
                // fileReader.readAsText(file);
                // fileReader.onload = (event) => {
                //     const bstr = event.target.result;
                //     const workbook = XLSX.read(bstr, { type: 'binary' });
                //     const sheetName = workbook.SheetNames[0]; // Lấy tên sheet đầu tiên
                //     const worksheet = workbook.Sheets[sheetName];
                //     const json = XLSX.utils.sheet_to_json(worksheet); // Chuyển đổi sheet thành JSON
                //     console.log("JSON: ", json);
                //     setData(json);
                // };
                fileReader.readAsArrayBuffer(file);
            } catch (exception) {
                setNotice("Có lỗi cảy ra: ", exception)
                console.log("ERROR: ", exception);
            }

        }
    };


    const noticeColor = running ? "green" : "blue";

    return (
        <div>
            <h1 style={{ marginTop: "20px" }}>Nhập dữ liệu hàng loạt qua tệp Excel hoặc CSV</h1>
            <div>
                <a href="/Import-user-template-tedy-math.xlsx" download="Import-user-template-tedy-math.xlsx">Tải file mẫu tại đây</a>
            </div>
            <br />
            <input type='file'
                id='file'
                className='input-file'
                accept='.csv, .xlsx, .xls'
                // onChange={e => handleFileChosen(e.target.files[0])} 
                onChange={e => handleFileUpload(e.target.files[0])}
            />

            <div style={{ display: 'flex' }}>
                <p style={{ marginRight: "10px" }}>Tình trạng: <span style={{ color: noticeColor }}>{notice}</span></p>
                {running ? <Spin /> : null}
            </div>
            <div style={{ marginBottom: "10px" }}>
                <span>{current}/{totalTask}</span>
                <Progress percent={percent} status="active" />
            </div>
            <Button onClick={stop} type="danger" disabled={!running}>Stop</Button>
            <Row style={{ marginTop: "10px" }}>
                <Col span={9}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "left" }}>
                        <span style={{ fontWeight: "bold", color: "darkblue" }}>Warning:</span>
                        {warning.map((w, index) => {
                            switch (w.type) {
                                case "pass": return <span key={index} style={{ fontSize: "small" }}>Tài khoản (userId) <span style={{ color: "blue" }}>{w.user.userId} </span> bị thiếu "Mật khẩu". Đã chuyển sang mật khẩu mặc định là {w.user.password} (Dòng {w.row}).</span>
                                case "school": return <span key={index} style={{ fontSize: "small" }}>Mã trường học (school) <span style={{ color: "blue" }}>{w.user.school} </span> chưa được tạo trước  (Dòng {w.row}).</span>
                                case "userId": return <span key={index} style={{ fontSize: "small" }}>Tài khoản (userId) <span style={{ color: "blue" }}>{w.user.userId} </span> bị trùng lặp  (Dòng {w.row}).</span>
                                case "maHs": return <span key={index} style={{ fontSize: "small" }}>Mã học sinh (maHs) <span style={{ color: "blue" }}>{w.user.maHs} </span> bị trùng lặp  (Dòng {w.row}).</span>
                            }
                            // return (
                            //     <span key={index} style={{ fontSize: "small" }}>Tài khoản (userId) <span style={{ textDecoration: "line-through", color: "blue" }}>{user.userId} </span> bị trùng lặp.</span>
                            // );
                        })}
                    </div>
                </Col>
                <Col span={15}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "left" }}>
                        <span style={{ fontWeight: "bold", color: "darkblue" }}>Errors:</span>
                        {errors.map((part, index) => {
                            console.log("ERROR: ", part)
                            return (
                                <span style={{marginTop:'5px'}} key={index}>* <span style={{ color: "red", fontSize: "10" }}>{part.maHs} {part.name ? `(${part.name})  -` : ""} {part.error}</span><span>   </span></span>
                            );
                        })}
                    </div>
                </Col>
            </Row>
        </div>
    );
}